import React, { memo } from 'react';

import { SegmentedTabs, Panel } from './Subtabs';
import SwishSync from './SwishSync';
import SwishSettings from './SwishSettings';
import { useHasCapability } from './Capabilities';

// The Swish area: the treasurer's daily Synk, plus the Inställningar map editor (§17). `active`
// is forwarded to Synk so it pre-loads its default window (fiscal-year start) on first activation.
// memo so an unrelated tab switch (which re-renders MainNavigation) doesn't reconcile the Swish
// subtree — its map editors are heavy. `active` only changes when this tab is entered/left.
const SwishTab = memo(({ active }: { active?: boolean }) => {
    // Inställningar holds three separately-gated maps (categories, the default placement, poster
    // messages). A role with none of them would open an empty panel, so the tab itself goes.
    // Each read on its own line: `a() || b()` would short-circuit, and a hook that runs on some
    // renders and not others is exactly what the rules of hooks forbid.
    const canCategories = useHasCapability('config.swish_categories')
    const canDefault = useHasCapability('config.swish_default')
    const canMessages = useHasCapability('config.swish_messages')
    const canConfigure = canCategories || canDefault || canMessages

    const panels: Panel[] = [{ slug: 'synk', label: 'Synk', panel: a => <SwishSync active={a}/> }]
    if (canConfigure) {
        panels.push({ slug: 'installningar', label: 'Inställningar', panel: () => <SwishSettings/> })
    }
    return <SegmentedTabs active={active} panels={panels}/>
})

export default SwishTab
